import { t } from '@/i18n'
import type { Tab } from '@/types'

import { EmptySeparator, Label, SubTitle } from './components'

function getKitchenNoteTitle() {
  return [new SubTitle(`${t('ordering.kitchen-note')}`, { fontSize: 32 })]
}

function getKitchenNoteTable(tab: Tab) {
  return [
    new SubTitle(`${t('kitchen-order.delivery-time')}: ${tab.tableName}`, {
      fontSize: 24
    })
  ]
}

function getKitchenNoteCourse(courseLabel: string) {
  return [
    new SubTitle(`${t('ordering.send-kitchen-note')}`, {
      fontSize: 50
    }),
    new SubTitle(courseLabel, { fontSize: 50 })
  ]
}

function getKitchenNoteActualDateAndHour() {
  return [
    new Label(new Date(), {
      style: '18px',
      lineHeight: 30,
      valueType: 'date',
      align: 'center'
    })
  ]
}

function generateKitchenNote(courseLabel: string, tab: Tab) {
  return [
    ...getKitchenNoteTitle(),
    new EmptySeparator(),
    ...getKitchenNoteTable(tab),
    ...getKitchenNoteActualDateAndHour(),
    new EmptySeparator(),
    new EmptySeparator(),
    ...getKitchenNoteCourse(courseLabel)
  ]
}

export default generateKitchenNote
